<form>
<h2>Integrate PDF File Viewer in Angular</h2>
<pdf-viewer
  [src]="pdfSrc"
  [render-text]="true"
  [original-size]="false"
  style="width: 800px; height: 600px"
></pdf-viewer>
<div class="card border-light shadow-sm">
    <div class="contact-details opensans-semi-bold-sapphire-30px">
      <span class="opensans-semi-bold-sapphire-30px">Vehicle Details</span>
    </div>
    <div class="rectangle-34"></div>
    <span class="opensans-semi-bold-black-16px-2"><b>Please ensure documents being submitted are clear and visible, any document that is not clear and visible will be rejected.</b></span>
    <span class="opensans-semi-bold-black-16px-2"><b>All foreign documents must be translated by a certified translator into English.</b></span>
    
    <div class="row m-0">
      <table style="width:100%;">
        
        <ng-container  *ngFor="let UserDocument of uploadedDocs; let i=index;" >
        <tr>
         
          <td>
          <div class="contact-details opensans-bold-sapphire-20px">
            <span class="opensans-bold-sapphire-20px">{{UserDocument.description}}</span>
             </div>
          <div class="rectangle-34"></div>
          <br/>
      <div>
        <!-- {{filename}} -->
      </div>
      <div class="dropzone" fileDragDrop (filesChangeEmiter)="onFileChange($event)">
        <div class="text-wrapper">
          <div class="centered">
            <img src="/assets/upload_icon.png" style="width: 21.33px;"/>
            <input id="fileuploads{{UserDocument.id}}" #fileuploads{{UserDocument.id}} type="file" style="width:100px;" (change)="handleTempFileInput($event,UserDocument.id)" />
            <br/>
            <label for="fileuploads{{UserDocument.id}}"><span class="textLink">Drag and drop files here or search on your computer</span> <br/><br/>
             <span></span>Upload</label>
          </div>
        </div>
      </div>
    </td>
          <td></td>
          <td style="padding-right: 20px;">
           
          </td>

          <td></td>


        </tr>
        <label><span class="txt-max"> Max file size {{maxMB}} PDF format.</span></label>
        <tr *ngFor="let Document of viewDocuments">
          <td *ngIf="UserDocument.id == Document.document_type_id">
            <div class="overlap-group13">
              <div class="rectangle-125"></div>
              <div class="files-uploaded-1 opensans-semi-bold-black-20px">
                <span class="opensans-semi-bold-black-20px">Files Uploaded</span>
              </div>
              <div class="overlap-group2 opensans-normal-black-20px-2">
                <div class="x-certificate">
                  <span class="opensans-normal-black-20px-2">{{UserDocument.file_name}}</span>
                </div>
                <div class="file-upload-icons-group">
                  <img title="View Document" class="file-upload-icon" src="/assets/visibility.png" alt="visibility"  aria-hidden="true" data-toggle="modal" data-target="#exampleModalLong" (click)="viewTempDoc(UserDocument.document_link,UserDocument.file_name)" />
                  <img title="Delete Document" class="file-upload-icon" (click)="deleteTempDoc(UserDocument)" src="/assets/delete.png" alt="delete" />
                </div>


              </div>
          
         
            </div>

            <div></div>
          </td>
      
        
          <td></td>
        </tr>
      </ng-container>


        <tr *ngIf="uploadedDocs.length==0">
          <td>No Documents found</td>
        </tr>

      </table>
    </div>
  </div>
</form>
